import { render, staticRenderFns } from "./viewbigpictures.vue?vue&type=template&id=6c840632&scoped=true"
import script from "./viewbigpictures.vue?vue&type=script&lang=js"
export * from "./viewbigpictures.vue?vue&type=script&lang=js"
import style0 from "./viewbigpictures.vue?vue&type=style&index=0&id=6c840632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c840632",
  null
  
)

export default component.exports